import { VendorTrackerTab } from './VendorTrackerTab'

export const VendorTrackerComponents = ({
    onRemove
}) => {
	return (
		<>
			<VendorTrackerTab
                onRemove={onRemove}
            />
		</>
	)
}
